import * as Yup from 'yup';
export const initialValues = {
    email: '',
};
export const validationSchema = Yup.object().shape({
    email: Yup.string()
        .email('A valid email address is required.')
        .required('An email address is required.'),
});
